exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vsg-container[data-v-4df5c018]{display:block;position:relative;width:100%}", ""]);

// exports
